// extracted by mini-css-extract-plugin
export var addButton = "_54-d";
export var bullets = "_54-e";
export var compact = "_54-2";
export var container = "_54-j";
export var extendedWarrantyModal = "_54-f";
export var learn = "_54-l";
export var learnMore = "_54-g";
export var offeringOption = "_54-3";
export var offeringPrice = "_54-8";
export var offeringSubtitle = "_54-7";
export var offeringTitle = "_54-6";
export var offeringsContainer = "_54-0";
export var pdpTilesBackground = "_54-n";
export var plan = "_54-m";
export var regular = "_54-1";
export var remove = "_54-k";
export var seeDetailsIcon = "_54-i";
export var seeDetailsLink = "_54-h";
export var selectedOption = "_54-4";
export var shieldIcon = "_54-b";
export var shieldIconCompact = "_54-c";
export var subtitle = "_54-a";
export var title = "_54-9";
export var unselectedOption = "_54-5";